<!--
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
-->
<!--
  Program: RegexInput
  Author: SDL
  Brief: Input using regex
-->
<template>
  <input @input="updateValue($event.target.value)" @change="emitChange" v-model="val" ref="input" v-bind="$attrs" />
</template>

<script>
import _ from 'lodash';

export default {
  name: 'sdl-regex-input',
  props: {
    value: {
      required: false,
      type: [Number, String],
    },
    regExp: {
      type: RegExp,
      default: null,
    },
  },
  data() {
    return {
      val: '',
      oldVal: '',
    };
  },
  methods: {
    isValid(val) {
      return _.isEmpty(val) || val.toString().match(this.regExp);
    },
    // update the value of input
    updateValue(val) {
      const newValue = this.isValid(val) ? val : this.oldVal;
      this.val = newValue;
      this.oldVal = newValue;
      this.emitInput(newValue);
    },
    // emit input event
    emitInput(val) {
      this.$emit('input', val);
    },
    // emit change event
    emitChange() {
      this.$emit('change', this.val);
    },
  },
  watch: {
    // watch value prop
    value(val) {
      this.updateValue(val);
    },
  },
  mounted() {
    this.updateValue(this.value);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/control/input/RegexInput.vue